import { ReactNode } from 'react';

import { Card } from '@components/card';

/**
 * Card wrapper shared by the global Manage tab and the per-job Journeys tab
 * so the two screens keep identical section chrome.
 */
export const SectionBox = ({ children }: { children: ReactNode }) => (
  <Card space={6}>{children}</Card>
);
